/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
import React, { Component } from 'react';

import Classes from './ConfigurationScreenContentPlaylistItem.css';

class ConfigurationScreenContentPlaylistItem extends Component {
  render() {
    return (
      <div className={`row ${Classes.CardContainerItem}`}>
        <div onClick={() => this.props.eventOpenModal(this.props.allSong)} className="col-1 align-self-center">
          <img src={this.props.picture} className={Classes.PictureUser} title="img" alt="img" />
        </div>
        <div onClick={() => this.props.eventOpenModal(this.props.allSong)} className="col-8 align-self-center">
          <p className={Classes.SongText}>
            <b>{this.props.artist}</b>
            <br />
            {` ${this.props.title}`}
          </p>
        </div>
        <div className="col-3 align-self-center">
          <i className={`${Classes.IcPlay} fas fa-headphones-alt`} title="Preview the song" onClick={() => this.props.eventPreviewSong(this.props.preview)} />
          &nbsp;
          &nbsp;
          &nbsp;
          &nbsp;
          <i className={`${Classes.IcAdd} fas fa-plus-circle`} title="Add to playlist" onClick={() => this.props.eventAddSong(this.props.allSong)} />
          &nbsp;
          &nbsp;
          &nbsp;
          &nbsp;
          <i className={`${Classes.IcHot} fab fa-hotjar`} title="Play now this song" onClick={() => this.props.eventPlayNowSong(this.props.allSong)} />         
        </div>
      </div>
    );
  }
}


export default ConfigurationScreenContentPlaylistItem;
